var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container",attrs:{"id":"app"}},[_c('navbar',{key:_vm.navKey}),_c('div',{staticClass:"row",attrs:{"id":"content-body"}},[_c('div',{staticClass:"col-12"},[_c('router-view')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }